import { format } from 'date-fns';

import { CONSTANTS } from '../config/constants';

export const getCurrentDateForFilename = (): string => {
  return format(new Date(), CONSTANTS.DATE_FORMATS.DATE_TIME_FILENAME);
};
// Utility to handle UTC or string timestamps and return local time string
export function formatUtcToLocalString(ts?: Date | string | null): string {
  if (!ts) return '';
  let utcDate: Date;
  if (ts instanceof Date) {
    utcDate = ts;
  } else if (typeof ts === 'string') {
    utcDate = /Z|[+-]\d{2}:?\d{2}$/.test(ts) ? new Date(ts) : new Date(ts);
  } else {
    return '';
  }
  const localDate = new Date(
    Date.UTC(
      utcDate.getFullYear(),
      utcDate.getMonth(),
      utcDate.getDate(),
      utcDate.getHours(),
      utcDate.getMinutes(),
      utcDate.getSeconds(),
      utcDate.getMilliseconds(),
    ),
  );
  return localDate.toLocaleString();
}
